// initial state
import * as base from './base.js'
const baseName = '/admin/statistics'

const stateFacility = baseName + '/facility'
const stateKnowledge = baseName + '/knowledge'
const statePatrol = baseName + '/patrol'
const stateWork = baseName + '/work'
const stateTodayWork = baseName + '/todayWork'
const StateWorkType = baseName + '/workType'
const StateworkDisposeNew = baseName + '/workDisposeNew'
const StateworkCountAndEvaluate = baseName + '/workCountAndEvaluate'

const obj = base.setBaseUrl('', baseName)

const a = Object.assign(obj, { stateFacility, stateKnowledge, statePatrol, stateWork, stateTodayWork, StateWorkType, StateworkDisposeNew, StateworkCountAndEvaluate })
export default a
